﻿import AsyncStorage from '@react-native-async-storage/async-storage';
import { createClient } from '@supabase/supabase-js';
import { Platform } from 'react-native';
import 'react-native-url-polyfill/auto';

const supabaseUrl = 'https://kwbdebwzhrhtpnlkycgu.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt3YmRlYnd6aHJodHBubGt5Y2d1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ4NjEyNjMsImV4cCI6MjA4MDQzNzI2M30.d2l5vBjZS_UQWkt5xdL3pDls_iXZdiG6NOB2gQ8g8lA';

// Vérifie si on est côté client (navigateur) ou serveur (SSR)
const isClient = typeof window !== 'undefined';

// Storage adapté selon la plateforme
const getStorage = () => {
  if (Platform.OS === 'web') {
    // Sur web, utilise localStorage (seulement côté client)
    if (isClient) {
      return {
        getItem: (key: string) => Promise.resolve(localStorage.getItem(key)),
        setItem: (key: string, value: string) => {
          localStorage.setItem(key, value);
          return Promise.resolve();
        },
        removeItem: (key: string) => {
          localStorage.removeItem(key);
          return Promise.resolve();
        },
      };
    }
    // Côté serveur (SSR), pas de storage
    return undefined;
  }
  // Sur mobile, utilise AsyncStorage
  return AsyncStorage;
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: getStorage(),
    autoRefreshToken: isClient,
    persistSession: isClient,
    detectSessionInUrl: Platform.OS === 'web' && isClient,
  },
});